/** Pure display helpers for batch trainer assignments */

export function trainerDisplayName(trainer = {}) {
  return (
    trainer.fullName ||
    `${trainer.firstName || ''} ${trainer.lastName || ''}`.trim() ||
    trainer.email ||
    'Trainer'
  );
}

export function assignmentTrainerId(row) {
  return row?.trainerId || row?.trainer?.id || null;
}

export function parseTrainerListResponse(res) {
  const list = res?.data?.data ?? res?.data ?? [];
  return Array.isArray(list) ? list : [];
}
